module.exports = __webpack_public_path__ + "static/media/library.08289311.mp4";